'use strict';
import React, { Component } from 'react'
var FormatMessage = require('react-globalize').FormatMessage;

export default class WatchElderAbuse extends Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">

          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-12">
                  <h3 style={{textAlign:'center', color:"#0062a1", textDecoration: 'underline'}}>
                    TODOS DEBEMOS SER DEFENSORES Y AYUDANTES EN LA PREVENCIÓN DEL FRAUDE
                  </h3>
                  <h3 style={{textAlign:'center', color:"#0062a1", textDecoration: 'underline'}}>
                    ALERTAS DE PREVENCIÓN PARA QUE LOS ADULTOS MAYORES NO SEAN VÍCTIMAS DE ESTAFAS
                  </h3>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-9">
                  <p>
                    Cada año se informan más de 369 000 incidentes de explotación financiera de adultos 
                    mayores en los Estados Unidos, lo que provoca pérdidas por alrededor de $4800 millones, 
                    según un análisis de enero de 2022 de datos federales y estatales realizado por 
                    Comparitech , una empresa de investigación de seguridad cibernética.
                  </p>
                  <p>
                    No hay límite para la creatividad de quienes buscan robar y lamentablemente los adultos 
                    mayores son un blanco predilecto de estafadores y estafadores. Por lo general, estos 
                    delincuentes utilizan información personal y fotos descargadas de las redes sociales y 
                    arman estrategias y metodologías como la intimidación para estafar dinero a sus víctimas.
                  </p>
                  <p>
                    Desafortunadamente, en ocasiones quienes explotan a los adultos mayores son los más 
                    cercanos a ellos. Familiares, amigos y cuidadores se aprovechan de su proximidad para 
                    quedarse con algo de dinero, utilizar los bienes de la persona a la que cuidan de 
                    manera irresponsable, manipular dinero y bienes a su favor, o robar descaradamente 
                    grandes sumas de dinero creyendo que nadie se enterará.
                  </p>
                  <p>
                    El abuso financiero se puede prevenir antes de que comience. Debemos mantener comunicación 
                    con nuestros adultos mayores, y advertirles de las posibilidades de fraude a las que se 
                    están enfrentando.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/elderAbuse/grandfather.png" alt="alert" />
                </div>
              </div>
            </div> 
            
            :
            
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-12">
                  <h3 style={{textAlign:'center', color:"#0062a1", textDecoration: 'underline'}}>
                    WE ALL SHOULD BE ADVOCATES AND HELPERS IN THE PREVENTION OF FRAUD
                  </h3>
                  <h3 style={{textAlign:'center', color:"#0062a1", textDecoration: 'underline'}}>
                    PREVENTION ALERTS SO THAT OLDER ADULTS ARE NOT VICTIMS OF SCAMS
                  </h3>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-9">
                  <p>
                    More than 369,000 incidents of financial exploitation of older adults are reported each 
                    year in the United States, causing about $4.8 billion in losses, according to a January 
                    2022 analysis of federal and state data by Comparitech, a cybersecurity research company.
                  </p>
                  <p>
                    There is no limit to the creativity of those who seek to steal and unfortunately, older 
                    adults are a favorite target for swindlers and swindlers. Typically these criminals use 
                    personal information, and photos downloaded from social networks and put together 
                    strategies and methodologies such as intimidation to swindle money from their victims.
                  </p>
                  <p>
                    Unfortunately, sometimes those who exploit older adults are those closest to them. Family, 
                    friends, and caregivers take advantage of their proximity to keep some money, to use the 
                    assets of the person they care for irresponsibly, to manipulate money and assets in their 
                    favor, or to brazenly steal large sums of money believing that nobody will know.
                  </p>
                  <p>
                    Financial abuse can be prevented before it starts. We must maintain communication with 
                    our older adults, and warn them of the possibilities of fraud they are facing.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/elderAbuse/grandParentsEn.png" alt="alert" />
                </div>
              </div>
            </div> 
            
          }
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/elderAbuseContent/watchElderAbuse.js